enum ClientEntryPoints {
  getItem = '/api/sale/client/{uuid}',
  getCollection = '/api/sale/client/list',
  getCollectionDownload = '/api/sale/client/download/clients',
  getCollectionForShop = '/api/shop/sales/client/list',
}

export default ClientEntryPoints;
